Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
function curry(func) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (func.length <= args.length) {
            return func.apply(null, args);
        }
        else {
            return (_a = curry(func)).bind.apply(_a, [null].concat(args));
        }
        var _a;
    };
}
exports.curry = curry;
function range(min, max, makeKey) {
    var arr = [], index = min - 1;
    while (++index <= max)
        arr.push(makeKey ? makeKey(index) : { key: index, value: index });
    return arr;
}
exports.range = range;
exports.preventClick = function (e) {
    e = e || window.event;
    e.stopPropagation();
    e.preventDefault();
    return false;
};
function _loadSupplant() {
    String.prototype['supplant'] = function (o) {
        return this.replace(/{([^{}]*)}/g, function (a, b) {
            var r = o[b];
            return typeof r === 'string' || typeof r === 'number' ? r : a;
        });
    };
}
function _loadStringSplice() {
    if (!String.prototype['splice']) {
        String.prototype['splice'] = function (startAfterPosition, removeCount, stringToAdd) {
            return (this.slice(0, startAfterPosition) +
                stringToAdd +
                this.slice(startAfterPosition + Math.abs(removeCount)));
        };
    }
}
function preventLMSLeads(queryParams) {
    return (queryParams &&
        queryParams['network'] == 'facebook' &&
        queryParams['category'] == 'renewal');
}
function _loadNumberSuffixGetter() {
    Number.prototype['getSuffix'] = function () {
        return this < 11 || this > 13
            ? ['st', 'nd', 'rd', 'th'][Math.min((this - 1) % 10, 3)]
            : 'th';
    };
}
function loadScript(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) {
        script.onreadystatechange = function () {
            if (script.readyState == 'loaded' || script.readyState == 'complete') {
                script.onreadystatechange = null;
                callback();
            }
        };
    }
    else {
        script.onload = callback;
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
}
var utils = {
    isTrue: function (value) {
        var type = typeof value;
        return ((type === 'string' &&
            (value == 'true' ||
                (isNaN(value) && value != 'false') ||
                (!isNaN(value) && !!parseInt(value)))) ||
            ((type === 'number' || type === 'boolean') && value));
    },
    isEmpty: function (value) {
        if (typeof value === 'object') {
            if (Array.isArray(value))
                return !value.length;
            return !Object.keys(value).length;
        }
        return (value === undefined ||
            value === null ||
            value.toString().trim().length === 0);
    },
    simpleClone: function (obj) {
        var type = typeof obj;
        if (type === 'undefined' ||
            type === 'boolean' ||
            type === 'number' ||
            type === 'string' ||
            type === 'function' ||
            obj === null)
            return obj;
        return JSON.parse(JSON.stringify(obj));
    },
    loadCustomUtils: function () {
        _loadSupplant();
        _loadStringSplice();
        _loadNumberSuffixGetter();
        if (!window.location.origin) {
            var loc = window.location;
            var origin = loc.protocol + '//' + loc.hostname + (loc.port ? ':' + loc.port : '');
            loc.origin = origin;
        }
    },
    loadScript: loadScript,
    moneyFormat: function (value) {
        var returnValue;
        var valueWasNegative = false;
        if (value < 0) {
            value = value * -1;
            valueWasNegative = true;
        }
        var x = value.toString();
        var res = x;
        if (x.length > 3) {
            var afterPoint = '';
            if (x.indexOf('.') > 0)
                afterPoint = x.substring(x.indexOf('.'), x.length);
            x = Math.floor(x);
            x = x.toString();
            var lastThree = x.substring(x.length - 3);
            var otherNumbers = x.substring(0, x.length - 3);
            if (otherNumbers != '')
                lastThree = ',' + lastThree;
            res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
        }
        var sign = valueWasNegative ? '-' : '';
        returnValue = sign + ' ' + res;
        return returnValue;
    },
    addEmptyIframe: function () {
        var iFrame = document.createElement('iframe');
        iFrame.setAttribute('style', 'height:0px;width:0px;visibility:hidden');
        iFrame.setAttribute('src', 'about:blank');
        iFrame.nodeValue = 'Prevents BFC!';
        document.body.appendChild(iFrame);
    },
    preventLMSLeads: preventLMSLeads,
    verifyImageURL: function (URL, onSuccess, onFailure) {
        var img = new Image();
        img.onload = onSuccess;
        img.onerror = onFailure;
        img.src = URL;
    },
    getNumberMneunomic: function (num) {
        var _list = ['st', 'nd', 'rd', 'th'];
        return (num < 20 ? _list[num - 1] : _list[num % 10 - 1]) || _list[3];
    },
    parseMessages: function (messages, levelRange, count, type) {
        if (levelRange === void 0) { levelRange = '0-50'; }
        if (count === void 0) { count = 1; }
        if (type === void 0) { type = ''; }
        var INFINITE = 999999999;
        var levelArray = levelRange.split('-');
        var l1 = levelArray[0] && !isNaN(+levelArray[0]) ? +levelArray[0] : -1 * INFINITE;
        var l2 = levelArray[1] && !isNaN(+levelArray[1]) ? +levelArray[1] : INFINITE;
        var filteredMsgs = [];
        if (!Array.isArray(messages))
            return filteredMsgs;
        for (var i = 0; i < messages.length && filteredMsgs.length < count; i++) {
            if (messages[i].level >= l1 &&
                messages[i].level <= l2 &&
                (type === '' || messages[i].tags === type)) {
                filteredMsgs.push(messages[i].message);
            }
        }
        return filteredMsgs;
    },
    getUniqueValues: function (array) {
        return array.filter(function (val, index, self) {
            return self.indexOf(val) === index;
        });
    },
    addClass: function (selector, className) {
        document[selector] && document[selector].classList.add(className);
    },
    removeClass: function (selector, className) {
        document[selector] && document[selector].classList.remove(className);
    },
    addScriptTag: function (scriptText) {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        var code = scriptText;
        try {
            s.appendChild(document.createTextNode(code));
            document.body.appendChild(s);
        }
        catch (e) {
            s.text = code;
            document.body.appendChild(s);
        }
    },
    addBlankIFrame: function (src) {
        var ifrm = document.createElement('iframe');
        ifrm.setAttribute('src', src);
        ifrm.setAttribute('frameborder', '0');
        ifrm.setAttribute('marginheight', '0');
        ifrm.setAttribute('marginwidth', '0');
        ifrm.style.width = '0';
        ifrm.style.height = '0';
        ifrm.style.display = 'none';
        document.body.appendChild(ifrm);
    },
    isDealer: function () {
        return !!window['IS_DEALER'];
    },
    getFirstAndLastName: function (nameString) {
        if (nameString === void 0) { nameString = ''; }
        var firstSpaceIndex = nameString.indexOf(' ');
        firstSpaceIndex =
            firstSpaceIndex === -1 ? nameString.length : firstSpaceIndex;
        return {
            first_name: nameString.substr(0, firstSpaceIndex),
            last_name: nameString.substr(firstSpaceIndex + 1),
        };
    },
    getDateFormats: function (date, prefix) {
        if (prefix === void 0) { prefix = ''; }
        var DATE_FORMATS = ['D', 'DD', 'M', 'MM', 'MMM', 'YYYY'];
        var dateObj = moment(date, 'DD-MM-YYYY');
        var formattedDates = {};
        DATE_FORMATS.forEach(function (format) {
            formattedDates[prefix + format] = dateObj.format(format);
        });
        return formattedDates;
    },
    objToStr: function (data) {
        return Object.keys(data).reduce(function (str, key) {
            return "" + str + key + ": " + (typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key]) + "\n";
        }, '');
    },
    updateListsToString: function (data) {
        for (var property in data) {
            if (data[property] instanceof Array) {
                if (typeof data[property][0] !== 'object') {
                    data[property] = data[property].toString();
                }
                else {
                    for (var _i = 0, _a = data[property]; _i < _a.length; _i++) {
                        var obj = _a[_i];
                        utils.updateListsToString(obj);
                    }
                }
            }
            else if (typeof data[property] === 'object') {
                utils.updateListsToString(data[property]);
            }
        }
        return data;
    },
    toTitleCase: function (str) {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    },
    boolToZeroOne: function (value) { return (value ? 1 : 0); },
    sortObjectArrayByAlphabet: function (list, sortKey, ascending) {
        var typeMultiplier = ascending ? 1 : -1;
        list.sort(function (itemA, itemB) {
            return (itemA[sortKey] < itemB[sortKey] ? -1 : 1) * typeMultiplier;
        });
    },
    getListWithPrefixAlphabet: function (list, valueKey, numericReplacer) {
        if (numericReplacer === void 0) { numericReplacer = '#'; }
        var currentPrefixAlphabet = '';
        var listClone = list.slice();
        var tempFirstAlphabet = '';
        for (var i = 0; i < listClone.length; i++) {
            tempFirstAlphabet = listClone[i][valueKey][0];
            if (!isNaN(parseInt(tempFirstAlphabet)))
                tempFirstAlphabet = numericReplacer;
            if (tempFirstAlphabet !== currentPrefixAlphabet) {
                listClone[i]['prefixAlphabet'] = tempFirstAlphabet;
                currentPrefixAlphabet = tempFirstAlphabet;
            }
        }
        return listClone;
    },
    convertToSearchableText: function (value) {
        return value
            .toString()
            .replace(/[^a-zA-Z0-9]/g, '')
            .toLowerCase();
    },
    filterSearchKey: function (searchData, filterKey, searchAttribute) {
        var startsWith = [];
        var substringIn = [];
        var indexesSubstringIn = [];
        var indexesStartsWith = [];
        for (var index = 0; index < searchData.length; index++) {
            if (searchData[index][searchAttribute].startsWith(filterKey)) {
                startsWith.push(searchData[index]);
            }
            else if (searchData[index][searchAttribute].indexOf(filterKey) !== -1) {
                substringIn.push(searchData[index]);
            }
        }
        return startsWith.concat(substringIn);
    },
};
exports.default = utils;
